import React, { Component } from 'react';
import { connect } from 'react-redux';
import './CloseoutForm.css';
import Date from 'components/shared/text/Date';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import Button from 'components/shared/button/Button';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import MessageModal from 'components/shared/modal/MessageModal';
import { todayValidation } from 'services/utils/date-util';
import { Enterprise } from 'domain/enterprise';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { getCloseout } from 'components/admin/projects/details/project-closeout/store/selectors';
import {
  updateCloseout,
  requestCloseout,
} from 'components/admin/projects/details/project-closeout/store/actions';
import PropertyOwnerModal from 'components/admin/projects/details/project-closeout/PropertyOwnerModal';

class CloseoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this.initializeForm(props.closeout),
      showRequestConfirmation: false,
      showRequestConfirmationSuccess: false,
      showPropOwnerModal: false,
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { closeout } = this.props;
    const newCloseout = newProps.closeout;
    if (closeout !== newCloseout) {
      this.setState({ form: this.initializeForm(newCloseout) });
    }
  }

  initializeForm = (closeout) => {
    if (closeout) {
      return {
        warrantyDate: closeout.warranty_date,
        dueDate: closeout.due_date,
        requestedAt: closeout.requested_at,
      };
    }
  };

  handleAttributeChange = (attr, value) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [attr]: value,
        },
      },
      this.handleSave
    );
  };

  handleSave = () => {
    const { currentProject, dispatch } = this.props;
    const { form } = this.state;
    dispatch(updateCloseout(currentProject.id, form));
  };

  handleRequestConfirmation = () => {
    this.setState({ showRequestConfirmation: true });
  };

  sendRequest = () => {
    const { currentProject, dispatch } = this.props;
    dispatch(requestCloseout(currentProject.id)).then((response) => {
      if (response.ok) {
        this.setState({ showRequestConfirmationSuccess: true });
      }
    });
  };

  handleRequest = (confirmed) => {
    if (confirmed) {
      if (this.props.currentProject.building.property_owner_name) {
        this.sendRequest();
      } else {
        this.setState({ showPropOwnerModal: true });
      }
    }
    this.setState({ showRequestConfirmation: false });
  };

  handleDismissRequestSuccess = () => {
    this.setState({ showRequestConfirmationSuccess: false });
  };

  handlePropOwnerSubmit = () => {
    this.sendRequest();
    this.setState({ showPropOwnerModal: false });
  };

  handlePropOwnerClose = () => {
    this.setState({ showPropOwnerModal: false });
  };

  render() {
    const { currentProject } = this.props;
    const {
      form,
      showRequestConfirmation,
      showRequestConfirmationSuccess,
      showPropOwnerModal,
    } = this.state;
    const readOnly =
      currentProject &&
      !Enterprise.spackleOrGc(currentProject.contributor_type);
    return (
      form && (
        <React.Fragment>
          <div className="closeout-form">
            {form.requestedAt && (
              <div className="closeout-form-block">
                <label className="closeout-form-label">Requested On</label>
                <Date value={form.requestedAt} format="MM/DD/YY" />
              </div>
            )}
            <div className="closeout-form-block">
              <label className="closeout-form-label">Warranty Date</label>
              {readOnly ? (
                form.warrantyDate && (
                  <Date value={form.warrantyDate} format="MM/DD/YY" />
                )
              ) : (
                <DatetimePicker
                  placeholder="Warranty Date"
                  onChange={(value) =>
                    this.handleAttributeChange('warrantyDate', value)
                  }
                  value={form.warrantyDate}
                />
              )}
            </div>
            <div className="closeout-form-block">
              <label className="closeout-form-label">Closeout Due Date</label>
              {readOnly ? (
                form.dueDate && <Date value={form.dueDate} format="MM/DD/YY" />
              ) : (
                <DatetimePicker
                  isValidDate={todayValidation}
                  placeholder="Due Date"
                  onChange={(value) =>
                    this.handleAttributeChange('dueDate', value)
                  }
                  value={form.dueDate}
                />
              )}
            </div>
            {!readOnly && (
              <div className="closeout-form-block">
                <Button
                  className="button-orange"
                  label={
                    form.requestedAt ? 'Request Again' : 'Request Closeout'
                  }
                  disabled={!form.warrantyDate || !form.dueDate}
                  onClick={this.handleRequestConfirmation}
                />
              </div>
            )}
          </div>
          <hr />
          {showRequestConfirmation && (
            <ConfirmationModal
              show={showRequestConfirmation}
              message="Are you sure you want to send the Closeout Request email notification?"
              onHide={this.handleRequest}
            />
          )}
          {showRequestConfirmationSuccess && (
            <MessageModal
              show={showRequestConfirmationSuccess}
              message="An email has been sent to subcontractors requesting them to start uploading their Closeout documents."
              onHide={this.handleDismissRequestSuccess}
            />
          )}
          {showPropOwnerModal && (
            <PropertyOwnerModal
              show={showPropOwnerModal}
              onSubmit={this.handlePropOwnerSubmit}
              onClose={this.handlePropOwnerClose}
            />
          )}
        </React.Fragment>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    closeout: getCloseout(state),
  };
})(CloseoutForm);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-closeout/CloseoutForm.js